import { motion, MotionValue, useScroll, useTransform } from "framer-motion"
import { useRef } from "react"
import styled from "styled-components"

const StyledSectionWrapper = styled.div`
  height: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.black};
  justify-content: center;
  align-items: center;
  padding: 20px 20px 50px 20px;
  position: relative;
`

const StyledText = styled(motion.h2)`
  text-align: center;
  color: ${(p) => p.theme.colors.darkGrey};
  max-width: 500px;
  font-family: MazdaType, OENaPro, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  transition: all 0.5s ease-in-out;
  background-size: 100% !important;
  background-clip: text !important;
  -webkit-background-clip: text !important;
  color: ${(p) => p.theme.colors.transparent};
  transform-origin: 0%;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 28px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    white-space: pre-wrap;
  }
`
type ModelTextSectionProps = {
  text: string
}
function useBackroundChange(value: MotionValue<number>) {
  // value,
  // Map x from these values:[0, 1],
  // Into these values:
  //  [-distance, distance]
  return useTransform(
    value,
    [0, 0.5],
    [
      "linear-gradient(4.83deg, rgba(255, 255, 255, 0) 67.38%, #FFFFFF 293.68%)",
      "linear-gradient(82.94deg, rgba(255, 255, 255, 0) -219.49%, #FFFFFF 0.17%)",
    ]
  )
}
const ModelTextSection = ({ text }: ModelTextSectionProps) => {
  const ref = useRef(null)

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["end", "start"],
  })
  // const [hookedYPostion, setHookedYPosition] = useState("0%")
  // useEffect(() => {
  //   scrollYProgress.onChange((v) => setHookedYPosition(`${v * 100}%`))
  // }, [scrollYProgress])

  const background = useBackroundChange(scrollYProgress)

  return (
    <StyledSectionWrapper>
      <div ref={ref}>
        <StyledText
          style={{
            background,
          }}
        >
          {text}
        </StyledText>
      </div>
    </StyledSectionWrapper>
  )
}

export default ModelTextSection
